var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-sheet', {
    staticClass: "about-visual white--text image-card",
    staticStyle: {
      "background-image": "url(/images/sub/about/about-visual-bg.jpg)"
    }
  }, [_c('v-container', [_c('div', [_c('h2', {
    staticClass: "font-size-40 font-size-md-52 font-size-lg-72 line-height-13 mb-8 mb-lg-16"
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("마이스펙")]), _vm._v(" "), _c('br'), _vm._v(" 채용대행 서비스 ")]), _c('p', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_vm._v(" 마이스펙의 체계적인 채용프로세스에 운영사인 ㈜디엔아이씨 자체 DB, 커뮤니티, SNS 등을 활용하여 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 보다 빠르고 정확한 결과물을 만들어내는 서비스 입니다. ")]), _c('p', {
    staticClass: "page-text--lg"
  }, [_vm._v(" 정규직은 물론 프로젝트 단위 별 과업을 수행해야하는 MICE산업의 특성상 프로젝트 수행직 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" (전담인력, 전문프리랜서, 전문인력 등) 채용은 절대적이지만 많은 시간과 비용을 투자해야만 하는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 채용 업무를 마이스펙이 대행함으로써 기업 또는 담당PM은 본 프로젝트에 보다 집중할 수 있습니다. ")])])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "text-center mb-60 mb-md-100 mb-lg-140"
  }, [_c('h2', {
    staticClass: "font-size-40 font-size-md-52 font-size-lg-72 line-height-13 primary--text mb-8 mb-lg-16"
  }, [_vm._v(" MICEPEC Recruiting Agent ")]), _c('p', {
    staticClass: "page-text--lg line-height-13"
  }, [_vm._v(" 마이스펙의 채용서비스가 궁금해요! ")])]), _c('div', {
    staticClass: "tit-wrap text-center justify-center"
  }, [_c('h3', {
    staticClass: "font-size-28 font-size-md-36 font-size-lg-48 line-height-13"
  }, [_vm._v(" 채용서비스의 장점 ")])]), _c('v-row', _vm._l(_vm.advantage, function (item) {
    return _c('v-col', {
      key: item.title,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('v-card', {
      staticClass: "h-100",
      attrs: {
        "elevation": "0",
        "rounded": "lg",
        "color": "grey-f5"
      }
    }, [_c('v-layout', {
      staticClass: "pa-20 pa-md-30 pa-lg-40 text-center",
      attrs: {
        "column": "",
        "align-center": ""
      }
    }, [_c('v-img', {
      staticClass: "mb-16 mb-lg-40",
      attrs: {
        "src": item.icon,
        "max-width": "80"
      }
    }), _c('h4', {
      staticClass: "tit--sm line-height-1 mb-4 mb-lg-10"
    }, [_vm._v(_vm._s(item.title))]), _c('p', {
      staticClass: "font-size-14 font-size-lg-18 line-height-15 grey--text",
      domProps: {
        "innerHTML": _vm._s(item.sc)
      }
    })], 1)], 1)], 1);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "sub-section grey-f7"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center justify-center"
  }, [_c('h3', {
    staticClass: "font-size-28 font-size-md-36 font-size-lg-48 line-height-13"
  }, [_vm._v(" 채용서비스 영역 ")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('title-card', {
    attrs: {
      "title": "Basic Plan",
      "color": "primary lighten-3"
    }
  }, [_c('div', {
    staticClass: "circle-item circle-item--outlined grey-c"
  }, [_c('p', [_vm._v(" 인력 섭외 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 대행 서비스 ")])]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-15 grey--text mt-6 mt-lg-10"
  }, [_vm._v(" 필요인력 리스트 제공 ")])])], 1), _c('v-col', {
    staticClass: "mt-10 mt-md-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('title-card', {
    attrs: {
      "title": "Standard Plan",
      "color": "primary lighten-1"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "circle-item grey-f5"
  }, [_c('p', {
    staticClass: "grey--text"
  }, [_vm._v(" Basic Plan ")])]), _c('i', {
    staticClass: "icon icon-plus2 mx-6 mx-lg-6"
  }), _c('div', {
    staticClass: "circle-item circle-item--outlined grey-c"
  }, [_c('p', [_vm._v(" 행정서비스 대행 ")])])])], 1)], 1), _c('v-col', {
    staticClass: "mt-10 mt-lg-0",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('title-card', {
    attrs: {
      "title": "Premium Plan",
      "color": "primary darken-1"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "circle-item primary lighten-5"
  }, [_c('p', {
    staticClass: "primary--text"
  }, [_vm._v(" Standard Plan ")])]), _c('i', {
    staticClass: "icon icon-plus2 mx-6 mx-lg-6"
  }), _c('div', {
    staticClass: "circle-item circle-item--outlined grey-c"
  }, [_c('p', [_vm._v(" 현장 인력관리 대행 ")])])])], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section line-height-13 white--text image-card",
    staticStyle: {
      "background-image": "url(/images/sub/about/about-img.jpg)"
    }
  }, [_c('v-container', [_c('v-layout', {
    staticClass: "text-center",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "tit-wrap justify-center"
  }, [_c('h3', {
    staticClass: "font-size-28 font-size-md-36 font-size-lg-48"
  }, [_vm._v(" 서비스 문의 ")])]), _c('v-img', {
    staticClass: "mw-140px mw-lg-180px mb-20 mb-lg-40",
    attrs: {
      "src": "/images/sub/about/about-icon2.svg"
    }
  }), _c('v-divider', {
    staticClass: "primary lighten-2 border-2 border-lg-4 w-100 mx-auto mb-12 mb-lg-20",
    staticStyle: {
      "max-width": "30px"
    }
  }), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-15 mb-40 mb-lg-80"
  }, [_vm._v(" Tel. 02)325-9123 "), _c('br'), _vm._v(" E-mail. support@micepec.com ")]), _c('h4', {
    staticClass: "tit--sm word-keep-all mb-20 mb-lg-40"
  }, [_vm._v(" 채용대행 서비스의 시작 마이 스펙과 함께하세요 ")]), _c('v-btn', {
    staticClass: "grey-13--text",
    attrs: {
      "to": "/center/inquiry",
      "large": "",
      "color": "white"
    }
  }, [_c('span', {
    staticClass: "font-size-lg-20"
  }, [_vm._v("채용대행 서비스 문의")])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }